export const stats = [
  { number: '20+', label: 'YEARS IN COMMERCE' },
  { number: '10', label: 'ENGINEERS LED' },
  { number: '4', label: 'RETAIL BRANDS SCALED' },
  { number: '1', label: 'AI PRODUCT SHIPPED' },
];

export const positioningText = `I build engineering teams that run themselves. At Camping World, I lead a 10-person commerce engineering team that owns execution end-to-end. Leadership sends priorities, my team delivers. I also build AI products. ResumeXRays is a full-stack SaaS platform powered by Claude API and Deepgram voice AI that I designed, built, and shipped from scratch. Currently pursuing a Master's in Computer Science at Georgia Tech with a focus on AI and machine learning.`;

export const resumeXRays = {
  product: 'I designed, built, and shipped a full-stack SaaS platform that uses AI to level the playing field for job seekers. Users upload a resume and target job description, then the platform delivers detailed gap analysis, generates tailored cover letters, and runs live voice-powered mock interviews with real-time AI feedback. Every interaction feeds a data layer that gets smarter over time.',
  architecture: [
    { name: 'Claude API', desc: 'Resume analysis, cover letter generation, interview intelligence' },
    { name: 'Deepgram STT/TTS', desc: 'Real-time voice interviews with spoken AI feedback' },
    { name: 'Next.js / React / PostgreSQL / Redis', desc: 'Full-stack production platform' },
    { name: 'Data Pipeline', desc: 'Resume and job market analytics engine' },
  ],
  vision: 'Career preparation is broken. Professionals spend hours guessing what hiring managers want to hear. I built ResumeXRays to close that gap, an AI-powered platform that analyzes resumes, generates targeted materials, and conducts live practice interviews, all from a single upload.',
  url: 'https://www.resumexrays.com',
};

export const experience = [
  {
    period: '2020–Present',
    role: 'Director of Development',
    company: 'Camping World',
    progression: [
      { role: 'Lead Developer', year: '2020' },
      { role: 'IT Manager', year: '2022' },
      { role: 'Director', year: '2023' },
    ],
    narrative: 'Joined as a lead backend developer and earned two promotions in three years, ultimately building and leading a 10-person engineering organization. Own the full commerce technology stack across multiple storefronts, driving headless modernization and setting the technical direction for the platform.',
    highlights: [
      'Led digital modernization strategy across multiple commerce storefronts, including driving the headless migration initiative',
      'Built a 10-person engineering team through hiring, structure, and a leadership approach that drives collaboration and independence',
      'Pioneered AI-assisted development standards for the team, establishing governance including group code review protocols, automated pre-commit quality and security checks, and clear developer accountability for AI-generated code',
      'Established engineering culture including code review standards, 1:1 mentorship program, and accountability frameworks that improved velocity and retention',
      'Drove multi-system integration strategy connecting legacy platforms to modern commerce architecture',
      'Own the execution roadmap across business, agency, and vendor stakeholders. Single point of accountability for what ships and when',
    ]
  },
  {
    role: 'Lead Developer',
    company: "Carter's",
    progression: '2018–2020, 2012–2015',
    narrative: 'Returned to Carter\'s in a senior technical leadership role after three years of agency-side architecture work. Served as a senior technical lead for Salesforce Commerce Cloud, driving implementation of complex platform features across domestic and international storefronts.',
    highlights: [
      'Led technical implementation of complex commerce platform features, improving site performance and reliability',
      'Served as senior technical lead for SFCC projects across internal and external teams',
      'Led maintenance and support across multiple domestic and international storefronts',
      'Translated business requirements into technical specifications in collaboration with stakeholders',
    ]
  },
  {
    period: '2015–2018',
    role: 'Solutions Architect',
    company: 'Moku Collective',
    narrative: 'Led development operations at a commerce-focused agency, serving as the technical bridge between clients, platform capabilities, and vendor delivery. Architected solutions for complex commerce implementations while managing team workload and providing escalation support.',
    highlights: [
      'Led development team operations, managing workload distribution and providing technical direction',
      'Served as technical lead bridging client needs, platform capabilities, and third-party vendor delivery',
      'Developed technical requirements and architected solutions for complex commerce implementations',
      'Provided escalation support for team and clients to ensure platform stability',
    ]
  }
];

export const education = [
  {
    degree: 'Master of Science in Computer Science',
    focus: 'AI/ML Focus',
    school: 'Georgia Institute of Technology',
    year: 'Admitted, Fall 2026',
  },
  {
    degree: 'Bachelor of Science in Computer Science',
    school: 'Southern Polytechnic State University',
    year: '2005',
  },
];

export const technicalSkills = {
  'Commerce Platforms': ['Salesforce Commerce Cloud (SFCC)', 'Shopify', 'Vercel'],
  'AI & Data': ['Claude API', 'Deepgram', 'Python', 'Redis', 'PostgreSQL', 'GraphQL'],
  'Frontend & Architecture': ['React', 'Next.js', 'Node.js', 'FastAPI', 'JavaScript', 'HTML', 'CSS', 'Sass/SCSS'],
  'Code Quality': ['ESLint', 'Prettier', 'Semgrep', 'TypeScript'],
  'Tools': ['JIRA', 'Confluence', 'Figma', 'Git', 'GitHub', 'Bitbucket', 'Railway'],
  'Integrations': ['PayPal', 'Algolia', 'Avatax', 'Cybersource', 'Affirm', 'Amazon Pay', 'ApplePay', 'AWS S3', 'BazaarVoice', 'Bread', 'Carter', 'Channel Advisor', 'DoorDash', 'Feedonomics', 'Forter', 'Google Address Validation', 'Google Tag Manager', 'Kount', 'Narvar', 'OpenStreetMap', 'PerimeterX', 'Power Reviews', 'Stripe', 'Tealium', 'TurnTo', 'UsableNet', 'Yotta', 'Yotpo'],
};

export const certifications = [
  'Salesforce Commerce Cloud (SFCC) Certified Developer'
];

export const contactInfo = [];

export const socialLinks = [
  { icon: 'at', href: 'mailto:me@zachbiles.com', label: 'Email' },
  { icon: 'linkedin', href: 'https://linkedin.com/in/zachbiles', label: 'LinkedIn' },
  { icon: 'github', href: 'https://github.com/zbiles', label: 'GitHub' },
];
